import { render } from "./RemindersView.vue?vue&type=template&id=5b80cf38"
import script from "./RemindersView.vue?vue&type=script&lang=js"
export * from "./RemindersView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__